import React, { useState } from "react";

import PresetItem from "./PresetItem";

import presets from "../../datas/presets.json";
import arrowRight from "../../images/icon/icon-arrow-right.svg";

const PresetList = ({ addPresetItem }) => {
  const tabs = ["신선식품", "정육", "생선", "기타"];
  const [tabIdx, setTabIdx] = useState(0);

  return (
    <div className="right-area">
      <table className="preset-list-tab">
        <tbody>
          <tr>
            {tabs.map((t, index) => (
              <td
                key={index}
                className={index === tabIdx ? "tab-active" : "tab-inactive"}
              >
                <img
                  src={require(`../../images/icon/icon-preset-${index}.svg`)}
                  alt="preset-tab"
                />
                <p>{t}</p>
              </td>
            ))}
          </tr>
        </tbody>
      </table>
      <div className="preset-list-table">
        {presets.map((preset, index) => (
          <PresetItem item={preset} key={index} func={addPresetItem} />
        ))}
      </div>
      <div className="preset-list-pagination">
        <div className="paging-inactive">
          <p>이전</p>
          <img src={arrowRight} alt="page-up" />
        </div>
        <p>1 / 4</p>
        <div className="paging-active">
          <img src={arrowRight} alt="page-down" />
          <p>다음</p>
        </div>
      </div>
    </div>
  );
};

export default PresetList;
